/*global Backbone, _ */
'use strict';
var Backbone        = require('backbone');
var _               = require('lodash');
//var Hex             = require("crypto-js/enc-hex");
var SHA1            = require("crypto-js/hmac-sha1");
var BASE64          = require("crypto-js/enc-base64.js");

module.exports = Backbone.Model.extend({

    apiUrl_proxy: 'proxy.flex.php',
    apiUrl: 'https://voteapi-cloud.telescope.tv/api',
    apiUri: '/1.0/flex_messages',

    defaults: {
      apiKey: '',                         //probably required
      id: '',                             //required
      topics: '',                         //required
      user_name: '',                      //required
      message: '',                        //required
      screen_name: '',                    //optional
      timestamp: 0,                       //optional
      image: '',                          //optional
      video: '',                          //optional
      avatar: '',                         //optional
      user_score: 0,                      //optional
      country: '',                        //optional
      state: '',                          //optional
      source: 'flex',                     //required
      // ruleset_collection_id: undefined,   //optional
      custom_parameters: ''               //optional
    },

    version_check: '8Qdv6jUQg9g97f9C6gGH',

    /**
     * Initialize
     * @param  {Object} attrs   [description]
     * @param  {Object} options [description]
     */
    initialize: function(attrs, options) {
      if(options && options.version_id) this.version_id = options.version_id;
      
      this.apiUrl = options.apiUrl? options.apiUrl : this.apiUrl;
      this.apiUri = options.apiUri? options.apiUri : this.apiUri;

    },

    /**
     * The Flex model requires that the client provide a unique ID value.
     * Use this method to generate a big-ass random hash value to use as your ID.
     * @return {[type]} [description]
     */
    generateUniqueID: function() {
      //var hash = SHA1(JSON.stringify(this.attributes), Math.random() + Date.now() + '');
      //var id = Hex.stringify(hash);
      return _.uniqueId();
    },

    /**
     * Save
     * @param  {Object} attributes [description]
     * @param  {Object} options    [description]
     * @return {[type]}            [description]
     */
    save: function(attributes, options) {
      //Flex requires the ID to be set.
      if(this.get('id') === '' || this.get('id') === undefined || this.get('id') === null) {
        this.set( { 'id': this.generateUniqueID() }, { silent: true } );
      }

      //Flex requires the a new timestamp to be set for every call or it will overwrite the
      //newest item currently in moderation even though the new item has an unique id
      this.set( { 'timestamp': Date.now() }, { silent: true } );
      

      var params = {
          url: this.urlRoot(),
          type: 'POST',
          dataType: 'JSON'
      };

      if(options && options.url) options.url = this.prepareUrl(options.url);

      _.extend(params, options);
      return Backbone.Model.prototype.save.call(this, attributes, params);
    },

    /**
     * Save
     * @param  {Object} obj [description]
     */
    destroy: function(obj) {
      console.warn('Flex API model does not support the destroy method.');
    },

    /**
     * Fetch
     * @param  {Object} obj [description]
     */
    fetch: function(obj) {
      console.warn('Flex API model does not support the fetch method.');
    },

    /**
     * Override Backbone's urlRoot to generate the URL with hashed params.
     * @param {String} url [description]
     */
    prepareUrl: function(url) {
      var hash = this.jsonToHash(this);
      return (url + '?apiKey=' + this.get('apiKey') + 
              '&timestamp=' + this.get('timestamp') + 
              '&hash=' + encodeURIComponent(hash) +
              '&apiUrl=' + this.apiUrl +
              '&apiUri=' + this.apiUri);
    },

    /**
     * [urlRoot description]
     * @return {[type]} [description]
     */
    urlRoot: function() {
      return this.prepareUrl(this.apiUrl_proxy);
    },

    /**
     * [jsonToHash description]
     * @param  {String} jsonStr [description]
     * @return {[type]}         [description]
     */
    jsonToHash: function(jsonStr) {
      if(typeof jsonStr === 'object') jsonStr = JSON.stringify(jsonStr);

      var secret = this.version_id + this.version_check;
      var concat = this.get('apiKey') + this.get('timestamp') + this.apiUri + jsonStr;
      var hash = SHA1(concat, secret);

      return BASE64.stringify(hash);
    },

    /**
     * [fixedEncodeURIComponent description]
     * @param  {String} str [description]
     * @return {[type]}     [description]
     */
    fixedEncodeURIComponent: function(str) {
      return encodeURIComponent(str).replace(/[!'()]/g, escape).replace(/\*/g, '%2A');
    }

  }, {
    
    required_fields: [
      'id',
      'topics',
      // 'ruleset_collection_id',
      'user_name',
      'message',
      'country',
      'state',
      'custom_parameters'
    ],
    
    optional_fields: [
      // 'ruleset_collection_id',
      'screen_name',
      'timestamp',
      'image',
      'video',
      'avatar',
      'user_score'
    ]
});
